import en from "../local/en_us";
import ims_en from "./ims_en";
import ims_am from "./ims_am";
import am from "../local/am";
const translations = {
  en: {
    translation: Object.assign({}, en, ims_en),
  },
  am: {
    translation: Object.assign({}, am, ims_am),
  },
};
export default translations;
